"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$ = void 0;
/**
 * This is a dumb but effective way of generating a literal tuple that doesn't get inferred as an array.
 *
 * @param elements
 */
var $ = function () {
    var elements = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        elements[_i] = arguments[_i];
    }
    return elements;
};
exports.$ = $;
